import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'categories-results_screen-view';
/**
 * An event fired when the user lands on a category results page. Does not necessarily mean the content has loaded, simply fired upon landing on the screen.
 */
export function trackCategoriesResultsScreenView(navLinkIdentifier) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { navLinkIdentifier },
    });
}
